module.exports = __webpack_public_path__ + "img/00001.a1a52ae3.webp";